import FindMyDealBlock from './find-my-deal-block';
export default FindMyDealBlock;